import api from './api';

export const taskService = {
  async createTask(taskData) {
    const response = await api.post('/tasks', taskData);
    return response.data;
  },

  async getTasks(filters = {}) {
    const response = await api.get('/tasks', { params: filters });
    return response.data;
  },

  async getTaskById(id) {
    const response = await api.get(`/tasks/${id}`);
    return response.data;
  },

  async updateTask(id, taskData) {
    const response = await api.put(`/tasks/${id}`, taskData);
    return response.data;
  },

  async getChildTasks(parentId) {
    const response = await api.get(`/tasks/${parentId}/children`);
    return response.data;
  },

  async getDueDateRevisions(taskId) {
    const response = await api.get(`/tasks/${taskId}/due-date-revisions`);
    return response.data;
  }
};
